import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function WelcomeBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="39791" id="hero" className="relative h-screen min-h-[600px] w-full overflow-hidden bg-background text-foreground border-t-2 border-accent !bg-[url(https://sampsonconcreteandmasonry.net/wp-content/uploads/2026/04/image_wqa8l0o8.jpg)] !bg-[url(https://sampsonconcreteandmasonry.net/wp-content/uploads/2026/04/image_wqa8l0o8.jpg)]">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621168/img/dent_d_oche_lake_geneva_reflection.png)] bg-cover bg-center bg-fixed grayscale contrast-125" role="img" aria-label="High-precision industrial foundation background with poured concrete textures" />

      {}
      <div className="absolute inset-0 bg-black/80" />

      {}
      <div ref={ref} className={cn("relative z-10 flex h-full flex-col items-center justify-center px-4 text-center text-white transition-all duration-700 cubic-bezier(0.19, 1, 0.22, 1)", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20")}>
        {}
        <h1 className="max-w-5xl text-4xl font-default font-extrabold tracking-tighter leading-none drop-shadow-2xl !text-[hsl(167,85%,89%)] sm:text-6xl md:text-7xl lg:text-[5rem]">SAMPSON CONCRETE &amp; MASONRY</h1>

        {}
        <p className="mt-6 max-w-2xl text-lg font-default text-white/90 sm:text-xl md:text-2xl drop-shadow-md"><br /></p>

        {}
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <Button asChild className="h-12 rounded-[2px] bg-accent px-8 text-base font-bold text-black hover:bg-accent/90 shadow-xl border border-transparent transition-transform hover:scale-105">
            <Link to="/ProjectsPage">
              VIEW PROJECTS
            </Link>
          </Button>

          <Button asChild variant="outline" className="h-12 rounded-[2px] border-white bg-transparent px-8 text-base font-medium text-white hover:bg-white hover:text-black shadow-lg backdrop-blur-sm transition-transform hover:scale-105">
            <Link to="/ContactPage">
              GET IN TOUCH
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}